export class CourseProficiencyQuizConstant{
    public static readonly None: number = 0;
    public static readonly eQMSAutomatedGrading: number = 1;
    public static readonly eQMSTrainerGrading: number = 2;
    public static readonly PaperQuiz: number = 3;
}